import { Link } from 'react-router-dom';
import { categoryList } from '@/mocks/manga';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">樱花漫画</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed mb-4">
              樱花漫画提供漫画下载离线阅读，免费全集收藏追更。日漫韩漫国漫全覆盖，好看的漫画尽在樱花漫画。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              {categoryList.slice(1, 7).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  全部漫画
                </Link>
              </li>
              <li>
                <Link to="/category/riman" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  日漫专区
                </Link>
              </li>
              <li>
                <Link to="/category/hanman" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  韩漫专区
                </Link>
              </li>
              <li>
                <Link to="/category/guoman" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  国漫专区
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="space-y-3 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                <span>contact@yinghuamanhua.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line w-4 h-4 flex items-center justify-center"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center"></i>
                <span>上海市浦东新区张江高科技园区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-400">
            &copy; {currentYear} 樱花漫画 YingHuaManHua. 本站所有漫画均来自互联网，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4 text-sm text-background-400">
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}